import { Component, OnInit } from '@angular/core';
declare var $: any;
@Component({
  selector: 'app-nd-privacy-policy',
  templateUrl: './nd-privacy-policy.component.html',
  styleUrls: ['./nd-privacy-policy.component.css']
})
export class NdPrivacyPolicyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {

    if($(window).width() >= 992){
      $('#nd-home').removeClass('active');
      $('#nd-abt').removeClass('active');
      $('#nd-faq').removeClass('active');
      $('#nd-cact').removeClass('active');

      }

  }

}
